import { Component, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
declare const BrandVars;

@Component({
	selector: "app-mech-diag",
	templateUrl: "./mech-diag.component.html",
	styleUrls: ["./mech-diag.component.scss"]
})
export class MechDiagComponent {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	selectedcomponent: AssemblyConfig.Component;
	selectedshaft?: AssemblyConfig.Shaft | AssemblyConfig.MotorShaft;
	selectedmaintenance: string;
	public brand = BrandVars;

	constructor(public api: ApiService) { }

	selectComponent(component: AssemblyConfig.Component, shaft?: AssemblyConfig.Shaft | AssemblyConfig.MotorShaft) {
		this.selectedmaintenance = undefined;
		this.selectedcomponent = component;
		this.selectedshaft = shaft;
	}

	selectMaintenance(item: string) {
		this.selectedcomponent = undefined;
		this.selectedshaft = undefined;
		this.selectedmaintenance = item;
	}

	lookupLRU(component: AssemblyConfig.Component): string {
		if (component.lru) {
			const lru = this.components.lru.find(item => item.id === component.lru);
			if (lru) {
				return lru.name;
			}
		}
		return "";
	}

}
